export interface VideoItem {
  title: string;
  videoLink: string;
}

type YTCommand = 'pauseVideo' | 'playVideo' | 'seekTo';

const EMBED_PARAMS = 'fs=0&enablejsapi=1';

export const buildEmbedUrl = (url: string) => {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}${EMBED_PARAMS}`;
};

export const sendYTCommand = (
  iframe: HTMLIFrameElement | null,
  func: YTCommand,
  args: unknown[] = [],
) => {
  iframe?.contentWindow?.postMessage(JSON.stringify({ event: 'command', func, args }), '*');
};

export const enableYTListening = (iframe: HTMLIFrameElement) => {
  iframe.contentWindow?.postMessage(JSON.stringify({ event: 'listening' }), '*');
};

export const IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
